//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {NsIcon} from '@nuskin/ns-icon';
export default {
  name: 'Resources',
  components: {NsIcon},
  props: {
    /**
     * The resources that can be downloaded ([{ title, url image: { url, alt } }])
     */
    resources: {
      type: Array,
      default: () => []
    },

    /**
     * The variant/product sku to send to Google Analytics when the section is opened for the first time
     */
    productSku: {
      type: String,
      default: ''
    },

    /**
     * The variant/product name/title to send to Google Analytics when it's opened for the first time
     */
    productName: {
      type: String,
      default: ''
    }
  },
  methods: {
    pushProductDetailResourceAccessed(resource) {
      if (!this.productSku || !(resource || {}).url) {
        return;
      }
      const event = {
        event: 'productDetailResourceAccessed',
        ecommerce: {
          detail: {
            products: [
              {
                id: this.productSku,
                name: this.productName,
                resourceName: resource.title,
                resourceUrl: resource.url
              }
            ]
          }
        }
      };
      this.$store.commit('nuskin/pushGoogleAnalyticsEvent', event);
    }
  }
};
